import {
  Autocomplete,
  Box,
  Button,
  Divider,
  FormGroup,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { useContext, useEffect } from "react";
import SimulatorContext from "../../../../context/SimulatorContext";

interface Props {
  dipTube?: boolean;
  tubingScreen?: boolean;
}

export const PressureSimForm = ({ dipTube, tubingScreen }: Props) => {
  const {
    pressSimulatorValues,
    onUpdatePressSimulatorValues,
    onSimulatePressure,
    simulatorState,
    mergeVortexAndPressureDrop,
  } = useContext(SimulatorContext);

  // useEffect(() => {
  //   if (simulatorState.gas.vortex) {
  //     mergeVortexAndPressureDrop();
  //   }
  // }, []);

  const handleUpdateValues = (item: string, value: any) => {
    onUpdatePressSimulatorValues(item, value);
  };
  return (
    <Box
      sx={{
        pt: 1,
        "& .MuiTextField-root": { width: "100%" },
        "& .MuiAutocomplete-root": { width: "100%" },
        "& .MuiOutlinedInput-root": {
          borderRadius: "12px",
          backgroundColor: "rgba(255,255,255,0.7)",
          "&:hover": { backgroundColor: "rgba(255,255,255,0.9)" },
          "&.Mui-focused": { backgroundColor: "#fff" },
        },
      }}
    >
      <FormGroup>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography
              variant="subtitle2"
              sx={{
                mt: 1,
                mb: 0.5,
                fontWeight: 700,
                letterSpacing: "0.6px",
                textTransform: "uppercase",
                color: "rgb(140, 150, 169)",
              }}
            >
              General Data Entry
            </Typography>
            <Divider sx={{ borderColor: "rgba(140,150,169,0.2)", mb: 2 }} />
          </Grid>
          {dipTube && (
            <>
              <Grid item lg={4} sm={6} xs={12}>
                <TextField
                  type="number"
                  label="Reference Pressure [PIP] (psi)"
                  value={pressSimulatorValues.pip}
                  variant="outlined"
                      onChange={(event) =>
                    handleUpdateValues("pip", +event.target.value)
                  }
                />
              </Grid>
              <Grid item lg={4} sm={6} xs={12}>
                <TextField
                  type="number"
                  label="DeltaP"
                  value={pressSimulatorValues.deltaP}
                  variant="outlined"
                      onChange={(event) =>
                    handleUpdateValues("deltaP", +event.target.value)
                  }
                />
              </Grid>
              <Grid item lg={4} sm={6} xs={12}>
                <TextField
                  type="number"
                  label="Reference Depth [Pump Depth] (ft)"
                  value={pressSimulatorValues.refDepth}
                  variant="outlined"
                      onChange={(event) =>
                    handleUpdateValues("refDepth", +event.target.value)
                  }
                />
              </Grid>
              <Grid item lg={4} sm={6} xs={12}>
                <TextField
                  type="number"
                  label="Reservoir Pressure (psi)"
                  value={pressSimulatorValues.resPressure}
                  variant="outlined"
                      onChange={(event) =>
                    handleUpdateValues("resPressure", +event.target.value)
                  }
                />
              </Grid>
            </>
          )}
          {tubingScreen && (
            <>
              <Grid item lg={4} sm={6} xs={12}>
                <TextField
                  type="number"
                  label="# Screens"
                  value={pressSimulatorValues.numberOfTubingScreen}
                  variant="outlined"
                      onChange={(event) =>
                    handleUpdateValues(
                      "numberOfTubingScreen",
                      +event.target.value
                    )
                  }
                />
              </Grid>
              <Grid item lg={4} sm={6} xs={12}>
                <TextField
                  type="number"
                  label="Diameter"
                  value={pressSimulatorValues.diameter}
                  variant="outlined"
                      onChange={(event) =>
                    handleUpdateValues("diameter", event.target.value)
                  }
                />
              </Grid>
              <Grid item lg={4} sm={6} xs={12}>
                <Autocomplete
                  renderOption={(props, option) => {
                    return (
                      <li {...props} key={option}>
                        {option}
                      </li>
                    );
                  }}
                  isOptionEqualToValue={(option, value) => {
                    return true;
                  }}
                  value={pressSimulatorValues.slotSize}
                  onChange={(_, newValue) =>
                    onUpdatePressSimulatorValues("slotSize", newValue)
                  }
                  {...{
                    options: ["75", "50", "20", "15", "12", "10"],
                  }}
                  disablePortal
                      renderInput={(params) => (
                    <TextField {...params} label="Slot Size" />
                  )}
                />
              </Grid>
              <Grid item lg={4} sm={6} xs={12}>
                <TextField
                  type="number"
                  label="Open Area"
                  value={pressSimulatorValues.openArea}
                  variant="outlined"
                      disabled
                />
              </Grid>
              <Grid item lg={4} sm={6} xs={12}>
                <TextField
                  type="number"
                  label="Screen Length (ft)"
                  value={pressSimulatorValues.screenLength}
                  variant="outlined"
                      onChange={(event) =>
                    handleUpdateValues("screenLength", event.target.value)
                  }
                />
              </Grid>
            </>
          )}

          <Grid item lg={4} sm={6} xs={12}>
            <TextField
              type="number"
              label="Fluid Rate (BFPD)"
              value={pressSimulatorValues.bfpd}
              variant="outlined"
              onChange={(event) =>
                handleUpdateValues("bfpd", event.target.value)
              }
            />
          </Grid>
          <Grid item lg={4} sm={6} xs={12}>
            <TextField
              type="number"
              label="Gas Production (MSCFD)"
              value={pressSimulatorValues.gasRate}
              variant="outlined"
              onChange={(event) =>
                handleUpdateValues("gasRate", event.target.value)
              }
            />
          </Grid>
          <Grid item lg={4} sm={6} xs={12}>
            <TextField
              type="number"
              label="Water Cut (%)"
              value={pressSimulatorValues.wCut}
              variant="outlined"
              onChange={(event) =>
                handleUpdateValues("wCut", event.target.value)
              }
            />
          </Grid>
          <Grid item lg={4} sm={6} xs={12}>
            <TextField
              type="number"
              label="Water Rate (BWPD)"
              value={pressSimulatorValues.bwpd}
              variant="outlined"
              disabled
            />
          </Grid>
          <Grid item lg={4} sm={6} xs={12}>
            <TextField
              type="number"
              label="Oil Rate (BOPD)"
              value={pressSimulatorValues.bopd}
              variant="outlined"
              disabled
            />
          </Grid>
          <Grid item lg={4} sm={6} xs={12}>
            <TextField
              type="number"
              label="GOR (SCF/STB)"
              value={pressSimulatorValues.gor}
              variant="outlined"
              disabled
            />
          </Grid>
          {dipTube && (
            <>
              <Grid item lg={4} sm={6} xs={12}>
                <TextField
                  type="number"
                  label="Temperature (F)"
                  value={pressSimulatorValues.temperature}
                  variant="outlined"
                      onChange={(event) =>
                    handleUpdateValues("temperature", event.target.value)
                  }
                />
              </Grid>
              <Grid item lg={4} sm={6} xs={12}>
                <TextField
                  type="number"
                  label="Dip Tube ID"
                  value={pressSimulatorValues.DipTubId}
                  variant="outlined"
                      onChange={(event) =>
                    handleUpdateValues("DipTubId", event.target.value)
                  }
                />
              </Grid>
              <Grid item lg={4} sm={6} xs={12}>
                <TextField
                  type="number"
                  label="Dip Tube Length (ft)"
                  value={pressSimulatorValues.dipTubeLength}
                  variant="outlined"
                      onChange={(event) =>
                    handleUpdateValues("dipTubeLength", event.target.value)
                  }
                />
              </Grid>
            </>
          )}
          <Grid item lg={4} sm={6} xs={12}>
            <TextField
              type="number"
              label="API"
              value={pressSimulatorValues.api}
              variant="outlined"
              onChange={(event) =>
                handleUpdateValues("api", event.target.value)
              }
            />
          </Grid>
          {dipTube && (
            <>
              <Grid item lg={4} sm={6} xs={12}>
                <TextField
                  type="number"
                  label="Gas Specific gravity"
                  value={pressSimulatorValues.sp}
                  variant="outlined"
                      onChange={(event) =>
                    handleUpdateValues("sp", event.target.value)
                  }
                />
              </Grid>
              <Grid item lg={4} sm={6} xs={12}>
                <TextField
                  type="number"
                  label="Oil Specific gravity"
                  value={pressSimulatorValues.spo}
                  variant="outlined"
                      disabled
                />
              </Grid>
            </>
          )}
          <Grid item lg={4} sm={6} xs={12}>
            <TextField
              type="number"
              label="Specific gravity W"
              value={pressSimulatorValues.spw}
              variant="outlined"
              onChange={(event) =>
                handleUpdateValues("spw", event.target.value)
              }
            />
          </Grid>
          {dipTube && (
            <>
              <Grid item lg={4} sm={6} xs={12}>
                <TextField
                  type="number"
                  label="Viscocity (cP)"
                  value={pressSimulatorValues.viscocity}
                  variant="outlined"
                      onChange={(event) =>
                    handleUpdateValues("viscocity", event.target.value)
                  }
                />
              </Grid>
              <Grid item lg={4} sm={6} xs={12}>
                <TextField
                  type="number"
                  label="Gas Viscocity (cP)"
                  value={pressSimulatorValues.gasViscosity}
                  variant="outlined"
                      onChange={(event) =>
                    handleUpdateValues("gasViscosity", event.target.value)
                  }
                />
              </Grid>
            </>
          )}
          <Grid item lg={4} sm={6} xs={12}>
            <TextField
              type="number"
              label="Fluid Viscocity (cP)"
              value={pressSimulatorValues.viscocity}
              variant="outlined"
              onChange={(event) =>
                handleUpdateValues("viscocity", event.target.value)
              }
            />
          </Grid>
          {dipTube && (
            <>
              <Grid item lg={4} sm={6} xs={12}>
                <TextField
                  type="number"
                  label="Ap ft2"
                  value={pressSimulatorValues.ap}
                  variant="outlined"
                      onChange={(event) =>
                    handleUpdateValues("ap", event.target.value)
                  }
                />
              </Grid>
              <Grid item lg={4} sm={6} xs={12}>
                <TextField
                  type="number"
                  label="Surf. Tension (lb/s2)"
                  value={pressSimulatorValues.surfTension}
                  variant="outlined"
                      onChange={(event) =>
                    handleUpdateValues("surfTension", event.target.value)
                  }
                />
              </Grid>
            </>
          )}
        </Grid>
      </FormGroup>
      <Button
        variant="contained"
        disableElevation
        sx={{
          mt: 4,
          borderRadius: "12px",
          px: 4,
          py: 1,
          fontWeight: 600,
          textTransform: "none",
          backgroundColor: "rgb(140, 150, 169)",
          "&:hover": { backgroundColor: "rgb(115, 125, 145)" },
        }}
        onClick={onSimulatePressure}
      >
        Simulate
      </Button>
    </Box>
  );
};
